"use strict";
exports.__esModule = true;
exports.firstMatch = void 0;
var firstMatch = function (sep) {
    return function (str) { var _a; return (_a = str === null || str === void 0 ? void 0 : str.split(sep)) === null || _a === void 0 ? void 0 : _a[1]; };
};
exports.firstMatch = firstMatch;
//# sourceMappingURL=firstMatch.js.map